import { combineReducers } from 'redux';
import { playerCompareReducer } from '../components/playerCompare/store/reducer';
import { startSitReducer } from '../components/startSit/store/reducer';
import { trendingReducer } from '../components/trending/store/reducer';
import { postContestReducer } from '../components/postContest/store/reducer';
import { preContestReducer } from '../components/preContest/store/reducer';
import { contestGeneratorReducer } from '../components/contestGenerator/store/reducer';
import { lateSwapReducer } from '../components/lateSwap/store/reducer';
import { commonReducer } from '../components/common/store/reducer';
import { lineupBuilderReducer } from '../components/LineupBuilder/store/reducer';
import pick6Reducer from '../components/pick6/store/slice';
import pickemOptimizerReducer from '../components/pickemOptimizer/store/slice';
import stokasticPropsReducer from '../components/stokasticProps/store/slice';
import accountReducer from '../components/account/store/slice';

export default combineReducers({
  common: commonReducer,
  playerCompare: playerCompareReducer,
  startSit: startSitReducer,
  trending: trendingReducer,
  postContest: postContestReducer,
  preContest: preContestReducer,
  contestGenerator: contestGeneratorReducer,
  lateSwap: lateSwapReducer,
  lineupBuilder: lineupBuilderReducer,
  pick6: pick6Reducer,
  pickemOptimizer: pickemOptimizerReducer,
  stokasticProps: stokasticPropsReducer,
  account: accountReducer,
});

export interface IRootState {
  common: ReturnType<typeof commonReducer>;
  playerCompare: ReturnType<typeof playerCompareReducer>;
  startSit: ReturnType<typeof startSitReducer>;
  trending: ReturnType<typeof trendingReducer>;
  postContest: ReturnType<typeof postContestReducer>;
  preContest: ReturnType<typeof preContestReducer>;
  contestGenerator: ReturnType<typeof contestGeneratorReducer>;
  lateSwap: ReturnType<typeof lateSwapReducer>;
  lineupBuilder: ReturnType<typeof lineupBuilderReducer>;
  pick6: ReturnType<typeof pick6Reducer>;
  pickemOptimizer: ReturnType<typeof pickemOptimizerReducer>;
  stokasticProps: ReturnType<typeof stokasticPropsReducer>;
  account: ReturnType<typeof accountReducer>;
}